var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.364C8.28 9.364 10 7.644 10 5.364C10 3.084 8.28 1.364 6 1.364C3.72 1.364 2 3.084 2 5.364C2 7.644 3.72 9.364 6 9.364ZM6 3.364C7.178 3.364 8 4.186 8 5.364C8 6.542 7.178 7.364 6 7.364C4.822 7.364 4 6.542 4 5.364C4 4.186 4.822 3.364 6 3.364ZM7 10.364H5C2.243 10.364 0 12.607 0 15.364V16.364H2V15.364C2 13.71 3.346 12.364 5 12.364H7C8.654 12.364 10 13.71 10 15.364V16.364H12V15.364C12 12.607 9.757 10.364 7 10.364ZM16.364 0L14.95 1.414C16.271 2.737 17 4.495 17 6.364C17 8.233 16.271 9.991 14.95 11.314L16.364 12.728C18.064 11.027 19 8.767 19 6.364C19 3.961 18.064 1.701 16.364 0Z",
    fill: "#FFD252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanAudioIcon);
export default __webpack_public_path__ + "static/media/HumanAudioIcon.bb27523a5be1fea86932f73aa8a4a7d8.svg";
export { ForwardRef as ReactComponent };